import { useContext } from 'react';

import { useGraphThreadRunsForStatus } from '../api/useGraphSwr';
import { StateContext } from '../control/state';
import { isRunExecuting } from '../control/state.utils';

export const useInterruptShown = () => {
  const state = useContext(StateContext);
  const { data: activeRuns, isLoading: isLoadingActiveRuns } =
    useGraphThreadRunsForStatus(state.threadId, 'running');
  const { traceLog } = state;
  const output = traceLog[traceLog.length - 1];
  const isLastThreadState =
    !!state.threadHead &&
    output?.state?.checkpoint.checkpoint_id ===
      state.threadHead?.checkpoint.checkpoint_id;
  const hasTasks = !!state.threadHead?.next.length;
  const isIdle =
    !isRunExecuting(state.runState) &&
    state.runState.type !== 'empty' &&
    !activeRuns?.length;

  const interruptsShown =
    isLastThreadState && isIdle && hasTasks && !isLoadingActiveRuns;

  return interruptsShown;
};
